<sim-basic-material-dialog
	(closeClicked)="close({action: 'close'})"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerIcon]="{fontIcon: 'fa-filter', fontSet: 'fad'}"
	[headerText]="T.EVENT_FILTER_DIALOG_HEADER | translate"
	class="normalDuotoneHeaderIcon"
>
	<div dialogContent>
		<mat-tab-group [mat-stretch-tabs]="false" color="accent">
			<mat-tab label="{{ T.EVENT_FILTER_DIALOG_FILTER_TAB_HEADER | translate }}">
				<div class="tabContent">
					<!-- Filter Form -->
					<form class="filterContainer" [formGroup]="filterForm">
						<!-- Event Owner Filter -->
						<div class="filter">
							<div class="filterValue">
								<sim-user-chip-input
									[userFc]="filterForm.controls.ownerFilter"
									[label]="T.EVENT_FILTER_DIALOG_EVENT_OWNER | translate"
									[placeholder]="T.EVENT_FILTER_DIALOG_EVENT_OWNER | translate"
								/>
							</div>
							<div class="deleteFilter">
								<button
									mat-icon-button
									color="warn"
									[disabled]="!filterForm.controls.ownerFilter.length"
									(click)="clearOwnerValue()"
								>
									<mat-icon fontSet="fad" fontIcon="fa-trash" inline />
								</button>
							</div>
						</div>

						<!-- Scenario Filter -->
						<div class="filter">
							<div class="filterValue">
								<sim-scenario-chip-input
									[scenarioFc]="filterForm.controls.scenarioFilter"
									[label]="T.EVENT_FILTER_DIALOG_SCENARIO | translate"
									[placeholder]="T.EVENT_FILTER_DIALOG_SCENARIO | translate"
								/>
							</div>
							<div class="deleteFilter">
								<button
									mat-icon-button
									color="warn"
									[disabled]="!filterForm.controls.scenarioFilter.length"
									(click)="clearScenarioValue()"
								>
									<mat-icon fontSet="fad" fontIcon="fa-trash" inline />
								</button>
							</div>
						</div>

						<!-- Participants Filter -->
						<div class="filter">
							<div class="filterValue">
								<sim-user-chip-input
									[userFc]="filterForm.controls.participantsFilter"
									[canSelectMultipleUsers]="true"
									[label]="T.EVENT_FILTER_DIALOG_PARTICIPANTS | translate"
									[placeholder]="T.EVENT_FILTER_DIALOG_PARTICIPANTS | translate"
								/>
							</div>
							<div class="deleteFilter">
								<button
									mat-icon-button
									color="warn"
									[disabled]="!filterForm.controls.participantsFilter.length"
									(click)="clearPartValues()"
								>
									<mat-icon fontSet="fad" fontIcon="fa-trash" inline />
								</button>
							</div>
						</div>

						<!-- TrainingRoom Filter -->
						<div class="filter">
							<div class="filterValue">
								<sim-room-chip-input
									[roomFc]="filterForm.controls.roomFilter"
									[label]="T.EVENT_FILTER_DIALOG_ROOM | translate"
									[placeholder]="T.EVENT_FILTER_DIALOG_ROOM | translate"
									[canSelectMultipleRooms]="true"
								/>
							</div>
							<div class="deleteFilter">
								<button
									mat-icon-button
									color="warn"
									[disabled]="!filterForm.controls.roomFilter.length"
									(click)="clearRoomValues()"
								>
									<mat-icon fontSet="fad" fontIcon="fa-trash" inline />
								</button>
							</div>
						</div>

						<!-- Event Status Filter -->
						<div class="filter">
							<div class="filterValue">
								<mat-form-field color="accent" class="full-width-form">
									<mat-label>{{ T.EVENT_FILTER_DIALOG_EVENT_STATUS | translate }}</mat-label>
									<mat-select formControlName="eventStatusFilter" multiple>
										@for (eventStatus of eventStati; track eventStatus) {
											<mat-option [value]="eventStatus">{{ eventStatus | getEventStateString }}</mat-option>
										}
									</mat-select>
								</mat-form-field>
							</div>
							<div class="deleteFilter">
								<button
									mat-icon-button
									color="warn"
									[disabled]="filterForm.value.eventStatusFilter?.length === 0"
									(click)="filterForm.controls.eventStatusFilter.reset()"
								>
									<mat-icon fontSet="fad" fontIcon="fa-trash" inline />
								</button>
							</div>
						</div>

						<!-- Event date Filter -->
						<div class="filter">
							<div class="filterValue">
								<mat-form-field color="accent" class="full-width-form">
									<mat-label>{{ T.EVENT_FILTER_DIALOG_DATE_RANGE | translate }}</mat-label>
									<mat-date-range-input formGroupName="dateFilter" [rangePicker]="picker">
										<mat-label>{{ T.EVENT_FILTER_DIALOG_START_DATE | translate }}</mat-label>
										<input matStartDate formControlName="start" />
										<mat-label>{{ T.EVENT_FILTER_DIALOG_END_DATE | translate }}</mat-label>
										<input matEndDate formControlName="end" />
									</mat-date-range-input>
									<mat-datepicker-toggle matSuffix [for]="picker" />
									<mat-date-range-picker #picker />

									@if (filterForm.controls.dateFilter.controls.start.hasError("matStartDateInvalid")) {
										<mat-error>
											{{ T.EVENT_FILTER_DIALOG_ERROR_MESSAGE_START_DATE | translate }}
										</mat-error>
									}
									@if (filterForm.controls.dateFilter.controls.end.hasError("matEndDateInvalid")) {
										<mat-error>
											{{ T.EVENT_FILTER_DIALOG_ERROR_MESSAGE_END_DATE | translate }}
										</mat-error>
									}
								</mat-form-field>
							</div>
							<div class="deleteFilter">
								<button
									mat-icon-button
									color="warn"
									[disabled]="!filterForm.value.dateFilter.start && !filterForm.value.dateFilter.end"
									(click)="filterForm.controls.dateFilter.reset()"
								>
									<mat-icon fontSet="fad" fontIcon="fa-trash" inline />
								</button>
							</div>
						</div>

						<div class="filter">
							<div class="filterValue">
								<mat-checkbox formControlName="favoritesFilter">{{
									T.EVENT_FILTER_DIALOG_FAVORITES | translate
								}}</mat-checkbox>
							</div>
						</div>
					</form>
				</div>
			</mat-tab>
		</mat-tab-group>
	</div>

	<ng-container actions>
		<button color="accent" mat-raised-button [disabled]="filterForm.invalid" (click)="applyFilter()">
			{{ T.EVENT_FILTER_DIALOG_APPLY_BUTTON | translate }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
